import './avgourmet2/style';
import FormStructure from './avgourmet2/form_structure';

export default FormStructure;